<template>
  <Card class="main card-height-480">
    <v-toolbar height="50px" class="sub-header dialog-header" color="primary darken-1">
      <v-toolbar-title class="body-2">{{ $t('STATIC PLANT INFO') }}</v-toolbar-title>
      <v-spacer />
      <v-icon @click="$emit('close')">close</v-icon>
    </v-toolbar>
    <SimpleList :data="staticInfo" class="pl-4 pr-4" />
  </Card>
</template>

<script>
import {
  mapGetters
} from 'vuex'
import SimpleList from '@/components/common/SimpleList.vue'

export default {
  components: {
    SimpleList
  },
  data() {
    return {
      staticInfo: []
    }
  },
  computed: {
    ...mapGetters(['getPlantOverviewStaticInfo', 'getActivePlantInfo', 'getSelectedPlantId'])
  },
  mounted() {
    this.getStaticInfo()
  },
  methods: {
    getStaticInfo() {
      let oldPlantStaticInfo = this.getPlantOverviewStaticInfo
      let newPlantStaticInfo = this.getActivePlantInfo('plant_static_info')
      this.staticInfo = []
      if (newPlantStaticInfo !== null) {
        this.staticInfo = newPlantStaticInfo
      } else {
        Object.entries(oldPlantStaticInfo).forEach(([key, value]) => {
          let temp = {}
          temp['name'] = key
          temp['value'] = value
          this.staticInfo.push(temp)
        })
      }
    }
  },
  watch: {
    getSelectedPlantId() {
      this.getStaticInfo()
    }
  }
}
</script>

<style scoped>
	.card-height-480 {
		min-height: 550px;
		max-height: 600px;
		overflow-y: auto;
	}


  .dialog-header {
    position: sticky;
    top: 0;
  }
</style>
